import { render, staticRenderFns } from "./CaseFilePreview.vue?vue&type=template&id=99b927dc&scoped=true&"
import script from "./CaseFilePreview.vue?vue&type=script&lang=ts&"
export * from "./CaseFilePreview.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFilePreview.vue?vue&type=style&index=0&id=99b927dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99b927dc",
  null
  
)

export default component.exports